import React, { FC } from 'react';

import { EvTitle } from '@evinced-private/ui-common';

import { IssuesCount } from '../../services/queries/dashboard/helpers/transformResults';
import { AccessibilityCriticalIssuesStackedChartContainer } from '../accessibility-critical-issues-stacked-chart';
import { AccessibilityTrendsChartContainer } from '../accessibility-trends-chart/AccessibilityTrendsChartContainer';

interface BusinessUnitChartsSectionProps {
	dashboardData: IssuesCount[];
	isDashboardDataLoading: boolean;
	dashboardDataError: unknown;
}

export const BusinessUnitChartsSection: FC<BusinessUnitChartsSectionProps> = ({
	dashboardData,
	isDashboardDataLoading,
	dashboardDataError
}) => {
	return (
		<section className="trends-charts-section" role="group" aria-labelledby="trends-heading">
			<EvTitle id="trends-heading" titleText="Accessibility performance trends" />
			<div className="business-units-charts">
				<AccessibilityTrendsChartContainer />
				<AccessibilityCriticalIssuesStackedChartContainer
					data={dashboardData}
					isLoading={isDashboardDataLoading}
					error={dashboardDataError}
				/>
			</div>
		</section>
	);
};
